import React from 'react';

export default function AccuracyBadge({ vehicle, locale, onShopAccessories }) {
  if (!vehicle) return null;
  
  const sensors = {
    tpms: vehicle.has_tpms_oem,
    ambient: vehicle.has_ambient_temp_display,
    battery_temp: vehicle.has_battery_temp_obd,
    consumption: vehicle.has_consumption_display,
  };
  
  const missing = Object.entries(sensors).filter(([_, has]) => !has).map(([k]) => k);
  const present = Object.entries(sensors).filter(([_, has]) => has).map(([k]) => k);
  
  let band, color, label, message;
  
  if (missing.length === 0) {
    band = 3.0;
    color = '#20d9a6';
    label = 'High accuracy';
    message = 'Your car has all the sensors we need for precise predictions.';
  } else if (missing.length === 1) {
    band = 4.5;
    color = '#20d9a6';
    label = 'Good accuracy';
    message = `Predictions are reliable. Add a ${missing[0].replace('_', ' ')} sensor for the tightest estimates.`;
  } else if (missing.length === 2) {
    band = 6.0;
    color = '#ffb84d';
    label = 'Moderate accuracy';
    message = `Your car is missing ${missing.length} sensors we'd normally use. Accessories can close the gap.`;
  } else {
    band = 8.0;
    color = '#ff8a8a';
    label = 'Wider band';
    message = `Your car has limited sensors. Predictions stay useful but estimates will be wider.`;
  }
  
  return (
    <div style={{
      background: '#141414',
      border: `0.5px solid ${color}33`,
      borderLeft: `3px solid ${color}`,
      borderRadius: 12,
      padding: '12px 14px',
      marginBottom: 12,
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
        <div>
          <div style={{ fontSize: 10, color, textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 500, marginBottom: 2 }}>
            {label}
          </div>
          <div style={{ fontSize: 14, fontWeight: 500, color: '#fff' }}>
            ± {band.toFixed(1)} SoC points
          </div>
        </div>
        <div style={{ fontSize: 11, color: '#888', textAlign: 'right' }}>
          {present.length}/4 sensors<br/>
          <span style={{ fontSize: 9 }}>in vehicle</span>
        </div>
      </div>
      
      <div style={{ fontSize: 11, color: '#aaa', lineHeight: 1.4, marginBottom: missing.length > 0 ? 10 : 0 }}>
        {message}
      </div>
      
      {missing.length > 0 && (
        <button
          onClick={onShopAccessories}
          style={{
            width: '100%',
            background: 'transparent',
            color,
            border: `0.5px solid ${color}55`,
            padding: '8px 12px',
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Improve accuracy — shop accessories →
        </button>
      )}
    </div>
  );
}
